import { PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { Card, Flex } from '@applyboard/crystal-ui'
import { up } from '../../utils'
import { useGetSchool } from '../../hooks'
import { Loading } from '../Loading'
import { useGetSpaConfig } from '../../hooks/useGetSpaConfig'

export function OnBoardingBox(props: PropsWithChildren) {
  const { isLoadingSchool, school } = useGetSchool()
  const { ui } = useGetSpaConfig()

  const backgroundColor = ui?.signupBackgroundColour || '#F3F3F3'
  const signupLogoUrl = ui?.signupLogo?.['300x78']

  return (
    <PageContainer backgroundColor={backgroundColor}>
      <Flex align="center" grow={1} gap={20} py={{ xs: 12, sm: 20 }} direction="column">
        {isLoadingSchool ? (
          <Flex direction="column" justify="between">
            <Loading />
          </Flex>
        ) : (
          <>
            {school ? (
              <>
                <Flex hideBelow="sm">
                  <img alt={school?.attributes.name} src={signupLogoUrl} width={300} />
                </Flex>
                <Flex hideAbove="sm">
                  <img alt={school?.attributes.name} src={signupLogoUrl} width={138} />
                </Flex>
              </>
            ) : null}
            <Box>
              <Card>{props.children}</Card>
            </Box>
          </>
        )}
      </Flex>
    </PageContainer>
  )
}

const PageContainer = styled.div<{ backgroundColor: string }>(({ backgroundColor }) => ({
  backgroundColor,
  width: '100vw',
  minHeight: '100vh',
  display: 'flex',
  position: 'relative',
  paddingLeft: 55,
  paddingRight: 55,
  [up('sm')]: {
    paddingLeft: 15,
    paddingRight: 15,
  },
}))

const Box = styled.div(() => ({
  width: '100%',
  maxWidth: 600,
  '> section': {
    padding: '24px 8px',
  },
}))
